export const footerColumns = [
  {
    heading: "Expertise",
    links: ["Corporate Law", "Property", "Litigation", "Compliance"],
  },
  {
    heading: "Firm",
    links: ["About", "Our Approach", "Insights", "Careers"],
  },
  {
    heading: "Contact",
    links: ["London Office", "+44 (0)20 0000 0000", "hello@northgatelegal.co.uk"],
  },
  {
    heading: "Legal",
    links: ["Privacy", "Cookies", "Terms", "Complaints Procedure"],
  },
];

export const serviceOptions = ["Corporate Law", "Property", "Litigation", "Compliance", "Other"];
